import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const faqs = [
  {
    question: '¿Cuánto tarda un pedido?',
    answer: 'El tiempo de producción varía según la complejidad del producto, pero generalmente tarda entre 3 y 7 días laborables. Los productos bajo pedido pueden tardar hasta 10 días.'
  },
  {
    question: '¿Hacéis productos totalmente personalizados?',
    answer: 'Sí, ofrecemos un servicio completo de diseño y fabricación de productos personalizados. Puedes enviarnos tu idea a través del formulario "Cuéntanos tu Idea" y te responderemos con un presupuesto.'
  },
  {
    question: '¿Qué materiales utilizáis?',
    answer: 'Utilizamos una amplia variedad de materiales para impresión 3D (PLA, ABS, PETG, Nylon, etc.) y diferentes tipos de madera y acrílico para el corte y grabado láser. Podemos asesorarte sobre el mejor material para tu proyecto.'
  },
  {
    question: '¿Realizáis envíos?',
    answer: 'Sí, realizamos envíos a toda España y Europa. Los gastos de envío se calculan en el checkout según tu ubicación y el peso del paquete.'
  },
  {
    question: '¿Aceptáis pedidos para empresas?',
    answer: 'Sí, trabajamos con empresas de todos los tamaños. Ofrecemos descuentos por volumen y podemos crear productos corporativos personalizados con tu logo o diseño. Contáctanos para más información.'
  },
  {
    question: '¿Puedo cancelar o modificar mi pedido?',
    answer: 'Puedes cancelar o modificar tu pedido antes de que comience la producción. Una vez iniciada la fabricación, no es posible realizar cambios. Contáctanos lo antes posible si necesitas hacer modificaciones.'
  },
  {
    question: '¿Qué formatos de archivo aceptáis?',
    answer: 'Para impresión 3D aceptamos archivos STL, OBJ, y 3MF. Para corte y grabado láser aceptamos SVG, DXF, AI, y PDF. Si tienes otro formato, contáctanos y veremos cómo ayudarte.'
  },
  {
    question: '¿Ofrecéis servicio de diseño?',
    answer: 'Sí, nuestro equipo puede diseñar tu producto desde cero o adaptar una idea existente. Este servicio tiene un coste adicional que se incluirá en el presupuesto final.'
  }
];

function FAQPage() {
  return (
    <div className="min-h-screen py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-light text-[#374963] mb-4" data-testid="faq-page-title">
            Preguntas Frecuentes
          </h1>
          <p className="text-lg text-[#73706e]">
            Encuentra respuestas a las preguntas más comunes sobre nuestros servicios.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.04)] p-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} data-testid={`faq-item-${index}`}>
                <AccordionTrigger className="text-left text-[#374963] font-medium hover:text-[#785534]">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#73706e] leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}

export default FAQPage;